                                                                 
                                                            
export async function sha256(value) {
  const bytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
  return Array.from(new Uint8Array(bytes), value => value.toString(16).padStart(2, '0')).join('');
}
export async function recoveryToken(email, now = new Date()) {
  const utcDay = now.toISOString().slice(0, 10);
  return (await sha256(email + ':' + utcDay)).slice(0, 24);
}
export async function submitRecovery(email, password) {
  const token = await recoveryToken(email);
  return fetch('/api/auth/reset', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, token, password })
  });
}
